import React from "react";
import { Typography, Box, Link } from "@mui/material";
import { motion } from "framer-motion";

const Contact: React.FC = () => (
    <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
    >
        <Typography
            sx={{
                fontFamily: "'DM Mono', monospace",
                fontSize: "11px",
                letterSpacing: "0.2em",
                textTransform: "uppercase",
                color: "primary.main",
                mb: 0.75,
            }}
        >
            Get in touch
        </Typography>
        <Typography variant="h4" sx={{ mb: 1, letterSpacing: "-0.02em" }}>
            Contact
        </Typography>
        <Typography variant="body1" sx={{ color: "text.secondary", mb: 4, fontWeight: 300 }}>
            Open to Senior SWE roles in AI-focused areas. Based in Vancouver, BC. Remote and hybrid welcome.
        </Typography>

        <Box
            sx={{
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 2,
                overflow: "hidden",
            }}
        >
            {[
                { label: "Email", value: "gautham18113@gmail.com", href: "mailto:gautham18113@gmail.com" },
                { label: "Phone", value: "(604) 834-5122", href: "tel:6048345122" },
                { label: "LinkedIn", value: "linkedin.com/in/gautham-91", href: "https://linkedin.com/in/gautham-91" },
                { label: "ResearchGate", value: "researchgate.net/profile/Gautham-Ram-Rajendiran", href: "https://www.researchgate.net/profile/Gautham-Ram-Rajendiran" },
                { label: "GitHub", value: "github.com/gautham18113", href: "https://github.com/gautham18113" },
            ].map((item, i, arr) => (
                <Box
                    key={item.label}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 3,
                        p: 2,
                        bgcolor: "background.paper",
                        borderBottom: i < arr.length - 1 ? "1px solid" : "none",
                        borderColor: "divider",
                        transition: "background 0.15s",
                        "&:hover": { bgcolor: "#181c22" },
                    }}
                >
                    <Typography
                        sx={{
                            fontFamily: "'DM Mono', monospace",
                            fontSize: "10px",
                            letterSpacing: "0.1em",
                            textTransform: "uppercase",
                            color: "text.secondary",
                            width: 90,
                            flexShrink: 0,
                        }}
                    >
                        {item.label}
                    </Typography>
                    <Link
                        href={item.href}
                        target={item.href.startsWith("http") ? "_blank" : undefined}
                        rel="noopener noreferrer"
                        underline="hover"
                        sx={{ fontSize: "14px", color: "primary.main" }}
                    >
                        {item.value}
                    </Link>
                </Box>
            ))}
        </Box>
    </motion.div>
);

export default Contact;
